import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import * as fromApp from "../../../store/app.reducer";
import * as selectors from "../../../store/app.selectors";
import * as _ from "lodash";
import { Store } from "@ngrx/store";
import {
  auditTime,
  debounceTime,
  distinctUntilChanged,
  first,
} from "rxjs/operators";
import { Subscription } from "rxjs";
import * as CompleteOrderValidationActions from "../../../store/complete-order-validation/completeOrderValidation.actions";
import { TranslateService } from "@ngx-translate/core";
import { AlertController, ModalController } from "@ionic/angular";
import { Router } from "@angular/router";
import { DeliveryCostInfoModalComponent } from "src/app/popups/delivery-cost-info-modal/delivery-cost-info-modal.component";
import { InformationMessagesService } from "src/app/services/informationMessages/information-messages.service";
import { Capacitor } from "@capacitor/core";
import { PointsCalculationsService } from "src/app/services/pointsCalculations/points-calculations.service";
import { VatLevelsDetailsModalComponent } from "src/app/popups/vat-levels-details-modal/vat-levels-details-modal.component";
import { isGiftOnlyFreeOrder } from "src/app/services/gift-only-free-mode";
import {
  getPartialPaymentPrices,
  PartialPaymentPrices,
} from "./partial-payment-prices";

@Component({
  selector: "app-cart-prices",
  templateUrl: "./cart-prices.component.html",
  styleUrls: ["./cart-prices.component.scss"],
})
export class CartPricesComponent implements OnInit, OnDestroy {
  @Input() catalogMode: boolean;
  public subtotal: any;
  public discount_amount: any;
  public deliveryCost: any;
  public cartCustomOptionsTotalPrice: any;
  public vat_total;
  public grand_total_without_delivery_tips;
  public cartCustomOptionsTotalPriceWithoutTipsAndWrapperTax;
  public deliveryTipsTotal;
  public waiterTipsTotal;
  public wrapperTaxTotal;
  public currentOrderPoints: any;
  public points_deducted_from_coupon: any;
  public grand_total: any;
  public finalPriceLoading: boolean;
  public cartPrices: any;
  public partialPaymentPrices: PartialPaymentPrices | null = null;
  public cartProducts: any;
  public groupApp: any;
  public currentUser: any;
  public lastValidTimestamp: any = null;
  public cartActiveCoupons;
  public selectedCoupons;
  public showCouponDiscountMessage: boolean = false;
  public store_info: any;
  // ClickUp 86canwpzx - gift-only cart in a store running giftOnlyFreeMode: the
  // customer sees "free" instead of the wrapper tax and the total, while the order
  // itself keeps the tax and is sent as cash.
  public giftOnlyFreeOrder = false;
  public currentValidStore;
  public deliveryCostReplacedWithPrdMaxDeliveryCharge;
  public orderPickup;
  public dineIn;
  public selectedDineInTable;
  public cartInfoMessagesStore: any = {
    alert: null,
    inline: null,
    modal: null,
  };
  public cartInfoMessagesGroup: any = {
    alert: null,
    inline: null,
    modal: null,
  };
  public pointsDisableRuleArr;
  public selectedLang;
  public mo_base;
  public pointsFactorUsed: boolean;
  public pointsFactor;
  public pointsFactorReminder;
  public pointsFactorApplied;
  public pointsDisableRuleMessage: string;
  public enviromental_fee_translations: boolean = false;
  public filteredOrderCouponRules;

  private orderCouponRules;
  private cartCustomOptionsSelections;
  private selectedAddress;
  private deliveryCostInfoModal;
  private validStores;
  private vatLevelsDetailsModal: any;
  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store<fromApp.AppState>,
    private translateService: TranslateService,
    private alertController: AlertController,
    private modalController: ModalController,
    public pointsCalculationsService: PointsCalculationsService,
    private infoMessagesService: InformationMessagesService,
    private router: Router
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.store
        .select("auth")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && !_.isEqual(this.currentUser, state.user)) {
            this.currentUser = _.cloneDeep(state.user);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("groupApp")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.groupApp &&
            !_.isEqual(this.groupApp, state.groupApp)
          ) {
            this.groupApp = _.cloneDeep(state.groupApp);

            if (this.store_info && this.groupApp && this.currentOrderPoints) {
              this.calculatePointsFactor(
                this.groupApp,
                this.store_info,
                this.currentOrderPoints,
                Capacitor.isNativePlatform() ? "mobile" : "web"
              );
              this.refreshPointsFactorReminder();
            }

            this.mo_base = _.cloneDeep(
              _.find(state.groupApp.languages, {
                mo_base: true,
              })
            );

            if (!this.mo_base) {
              this.mo_base = "en";
            } else {
              this.mo_base = this.mo_base.code;
            }
          }

          if (
            state &&
            state.selectedLangugage &&
            !_.isEqual(this.selectedLang, state.selectedLangugage)
          ) {
            this.selectedLang = _.cloneDeep(state.selectedLangugage);
            this.refreshPointsFactorReminder();
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("cartActiveCoupons")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            !_.isEqual(this.cartActiveCoupons, state.activeCoupons)
          ) {
            this.cartActiveCoupons = _.cloneDeep(state.activeCoupons);
            if (this.cartActiveCoupons && this.cartActiveCoupons.length) {
              this.selectedCoupons = _.filter(this.cartActiveCoupons, {
                couponCheckbox: true,
              });
              // if (this.selectedCoupons && this.selectedCoupons.length) {
              //   this.checkAndShowCouponDiscountMessageDebounce();
              // }
            } else {
              //TO_DO WE CAN SHOW AN ALERT IF USER HAS PREVIOUSLY SELECTED A COUPON AND NOW NOT AVAILABLE
              this.selectedCoupons = [];
            }
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("disableFinalPrice")
        .pipe(distinctUntilChanged())

        .subscribe((state) => {
          if (
            state &&
            !_.isEqual(this.finalPriceLoading, state.disableFinalPrice)
          ) {
            if (!state.disableFinalPrice && this.finalPriceLoading) {
              this.checkAndShowCouponDiscountMessageDebounce();
            }

            this.finalPriceLoading = _.cloneDeep(state.disableFinalPrice);
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("orderCouponRules")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            !_.isEqual(this.orderCouponRules, state.orderCouponRules)
          ) {
            this.orderCouponRules = _.cloneDeep(state.orderCouponRules);

            this.filterOrderCouponRulesDebounced();
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select(selectors.getStoreInfo)
        .pipe(distinctUntilChanged())
        .subscribe((store_info) => {
          if (store_info && !_.isEqual(this.store_info, store_info)) {
            const previousStoreId = this.store_info?.store_id;
            this.store_info = _.cloneDeep(store_info);
            this.calculateGiftOnlyFreeOrder();

            if (previousStoreId !== this.store_info?.store_id) {
              this.checkCartInfoMessages();
            }

            if (this.store_info && this.groupApp && this.currentOrderPoints) {
              this.calculatePointsFactor(
                this.groupApp,
                this.store_info,
                this.currentOrderPoints,
                Capacitor.isNativePlatform() ? "mobile" : "web"
              );
              this.refreshPointsFactorReminder();
            }
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("cart")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.products &&
            !_.isEqual(this.cartProducts, state.products)
          ) {
            this.cartProducts = _.cloneDeep(state.products);
            this.calculateGiftOnlyFreeOrder();
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("deliveryMethodAddress")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (state && !_.isEqual(state.orderPickup, this.orderPickup)) {
            this.orderPickup = _.cloneDeep(state.orderPickup);
            this.filterOrderCouponRulesDebounced();
            if (this.groupApp && this.store_info && this.currentOrderPoints) {
              this.calculatePointsFactor(
                this.groupApp,
                this.store_info,
                this.currentOrderPoints,
                Capacitor.isNativePlatform() ? "mobile" : "web"
              );
              this.refreshPointsFactorReminder();
            } else if (
              this.groupApp &&
              this.store_info &&
              (!this.currentOrderPoints || this.currentOrderPoints === "0")
            ) {
              this.calculatePointsDisableRule(
                this.groupApp,
                this.store_info,
                this.currentOrderPoints,
                Capacitor.isNativePlatform() ? "mobile" : "web"
              );
              this.refreshPointsFactorReminder();
            }
          }

          if (
            state &&
            !_.isEqual(state.selectedDineInTable, this.selectedDineInTable)
          ) {
            this.selectedDineInTable = _.cloneDeep(state.selectedDineInTable);
          }
          if (state && !_.isEqual(state.dineIn, this.dineIn)) {
            this.dineIn = _.cloneDeep(state.dineIn);
            this.filterOrderCouponRulesDebounced();
            if (this.groupApp && this.store_info && this.currentOrderPoints) {
              this.calculatePointsFactor(
                this.groupApp,
                this.store_info,
                this.currentOrderPoints,
                Capacitor.isNativePlatform() ? "mobile" : "web"
              );
              this.refreshPointsFactorReminder();
            } else if (
              this.groupApp &&
              this.store_info &&
              (!this.currentOrderPoints || this.currentOrderPoints === "0")
            ) {
              this.calculatePointsDisableRule(
                this.groupApp,
                this.store_info,
                this.currentOrderPoints,
                Capacitor.isNativePlatform() ? "mobile" : "web"
              );
              this.refreshPointsFactorReminder();
            }
          }
          if (
            state &&
            !_.isEqual(state.selectedAddress, this.selectedAddress)
          ) {
            this.selectedAddress = _.cloneDeep(state.selectedAddress);
            if (this.selectedAddress) {
              this.store
                .select("currentStore")
                .pipe(first())
                .subscribe((currentStoreState) => {
                  const store_id = currentStoreState.currentStoreId;
                  if (state.validStores && state.validStores.length) {
                    this.currentValidStore = _.cloneDeep(
                      _.find(_.cloneDeep(state.validStores), {
                        store_id: store_id,
                      })
                    );
                  }
                });
            }
          }

          if (state && !_.isEqual(state.validStores, this.validStores)) {
            this.validStores = _.cloneDeep(state.validStores);
            if (this.selectedAddress) {
              this.store
                .select("currentStore")
                .pipe(first())
                .subscribe((currentStoreState) => {
                  const store_id = currentStoreState.currentStoreId;
                  if (state.validStores && state.validStores.length) {
                    this.currentValidStore = _.cloneDeep(
                      _.find(_.cloneDeep(state.validStores), {
                        store_id: store_id,
                      })
                    );
                  }
                });
            }
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("cartPrices")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          const partialPaymentPrices = getPartialPaymentPrices(state?.cartPrices);
          if (!_.isEqual(this.partialPaymentPrices, partialPaymentPrices)) {
            this.partialPaymentPrices = _.cloneDeep(partialPaymentPrices);
          }
          if (
            state &&
            state.cartPrices &&
            !_.isEqual(state.cartPrices, this.cartPrices)
          ) {
            this.cartPrices = _.cloneDeep(state.cartPrices);
            this.calculateGiftOnlyFreeOrder();

            if (this.cartPrices) {
              if (!_.isEqual(this.cartPrices.subtotal, this.subtotal)) {
                this.subtotal = _.cloneDeep(this.cartPrices.subtotal);
              }
              if (
                !_.isEqual(
                  this.cartPrices.discount_amount,
                  this.discount_amount
                )
              ) {
                this.discount_amount = _.cloneDeep(
                  this.cartPrices.discount_amount
                );
              }
              if (!_.isEqual(this.cartPrices.deliveryCost, this.deliveryCost)) {
                this.deliveryCost = _.cloneDeep(this.cartPrices.deliveryCost);
                if (
                  this.deliveryCost &&
                  parseFloat(this.deliveryCost.toString())
                ) {
                  this.deliveryCost = this.deliveryCost.toFixed(2);
                }
              }
              if (
                !_.isEqual(
                  this.cartPrices.cartCustomOptionsTotalPrice,
                  this.cartCustomOptionsTotalPrice
                )
              ) {
                this.cartCustomOptionsTotalPrice = _.cloneDeep(
                  this.cartPrices.cartCustomOptionsTotalPrice
                );
              }

              if (
                !_.isEqual(
                  this.cartPrices.deliveryCostReplacedWithPrdMaxDeliveryCharge,
                  this.deliveryCostReplacedWithPrdMaxDeliveryCharge
                )
              ) {
                this.deliveryCostReplacedWithPrdMaxDeliveryCharge = _.cloneDeep(
                  this.cartPrices.deliveryCostReplacedWithPrdMaxDeliveryCharge
                );
              }

              if (
                !_.isEqual(
                  this.cartPrices.grand_total_without_delivery_tips,
                  this.grand_total_without_delivery_tips
                )
              ) {
                this.grand_total_without_delivery_tips = _.cloneDeep(
                  this.cartPrices.grand_total_without_delivery_tips
                );
              }

              if (
                !_.isEqual(
                  this.cartPrices
                    .cartCustomOptionsTotalPriceWithoutTipsAndWrapperTax,
                  this.cartCustomOptionsTotalPriceWithoutTipsAndWrapperTax
                )
              ) {
                this.cartCustomOptionsTotalPriceWithoutTipsAndWrapperTax =
                  _.cloneDeep(
                    this.cartPrices
                      .cartCustomOptionsTotalPriceWithoutTipsAndWrapperTax
                  );
              }
              if (
                !_.isEqual(
                  this.cartPrices.deliveryTipsTotal,
                  this.deliveryTipsTotal
                )
              ) {
                this.deliveryTipsTotal = _.cloneDeep(
                  this.cartPrices.deliveryTipsTotal
                );
              }

              if (
                !_.isEqual(
                  this.cartPrices.waiterTipsTotal,
                  this.waiterTipsTotal
                )
              ) {
                this.waiterTipsTotal = _.cloneDeep(
                  this.cartPrices.waiterTipsTotal
                );
              }

              if (
                !_.isEqual(
                  this.cartPrices.wrapperTaxTotal,
                  this.wrapperTaxTotal
                )
              ) {
                this.wrapperTaxTotal = _.cloneDeep(
                  this.cartPrices.wrapperTaxTotal
                );
              }

              if (!_.isEqual(this.cartPrices.grand_total, this.grand_total)) {
                this.grand_total = _.cloneDeep(this.cartPrices.grand_total);
              }

              if (!_.isEqual(this.cartPrices.grand_total, this.grand_total)) {
                this.grand_total = _.cloneDeep(this.cartPrices.grand_total);
              }
              if (
                !_.isEqual(
                  this.cartPrices.currentOrderPoints,
                  this.currentOrderPoints
                )
              ) {
                this.currentOrderPoints = _.cloneDeep(
                  this.cartPrices.currentOrderPoints
                );

                if (
                  this.store_info &&
                  this.groupApp &&
                  this.currentOrderPoints
                ) {
                  this.calculatePointsFactor(
                    this.groupApp,
                    this.store_info,
                    this.currentOrderPoints,
                    Capacitor.isNativePlatform() ? "mobile" : "web"
                  );
                } else if (
                  this.store_info &&
                  this.groupApp &&
                  this.groupApp.pointsSystem &&
                  (!this.currentOrderPoints || this.currentOrderPoints === "0")
                ) {
                  this.calculatePointsDisableRule(
                    this.groupApp,
                    this.store_info,
                    this.currentOrderPoints,
                    Capacitor.isNativePlatform() ? "mobile" : "web"
                  );
                }
              }

              if (
                !_.isEqual(
                  this.cartPrices.points_deducted_from_coupon,
                  this.points_deducted_from_coupon
                )
              ) {
                this.points_deducted_from_coupon = _.cloneDeep(
                  this.cartPrices.points_deducted_from_coupon
                );
              }

              if (!_.isEqual(this.cartPrices.vat_total, this.vat_total)) {
                this.vat_total = _.cloneDeep(this.cartPrices.vat_total);
              }

              this.refreshPointsFactorReminder();
            }
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("completeOrderValidation")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.lastValidTimestamp &&
            !_.isEqual(this.lastValidTimestamp, state.lastValidTimestamp)
          ) {
            this.lastValidTimestamp = _.cloneDeep(state.lastValidTimestamp);
            this.cartPricesValidation();
          }
        })
    );

    this.subscriptions.push(
      this.store
        .select("cartCustomOptionsSelections")
        .pipe(distinctUntilChanged())
        .subscribe((state) => {
          if (
            state &&
            state.cartCustomOptionsSelections &&
            !_.isEqual(
              this.cartCustomOptionsSelections,
              state.cartCustomOptionsSelections
            )
          ) {
            this.cartCustomOptionsSelections = _.cloneDeep(
              state.cartCustomOptionsSelections
            );
            const plastic_wrapper_tax_option = _.find(
              this.cartCustomOptionsSelections,
              { preNameId: "plastic_wrapper_tax" }
            );

            if (
              plastic_wrapper_tax_option &&
              plastic_wrapper_tax_option.enviromental_fee_translations
            ) {
              this.enviromental_fee_translations = true;
            } else {
              this.enviromental_fee_translations = false;
            }
          }
        })
    );
  }

  // Coupon minimums are judged on food, not on gratuity. The calculate lambda
  // already feeds the rule a figure with both tips removed, but the exported
  // grand_total_without_delivery_tips deliberately keeps waiterTipsTotal inside
  // it so KDS Monitor and stats keep cross-checking against deliveryTipsTotal.
  // So the waiter tip is taken out here too, rounded the same way the lambda
  // rounds it. Without this the cart promises a coupon the backend never issues.
  showCreationMinOrderMessage(rule) {
    if (
      rule &&
      rule.creationMinOrder &&
      this.cartPrices &&
      this.cartPrices.grand_total_without_delivery_tips
    ) {
      const waiterTipsTotal = parseFloat(this.cartPrices.waiterTipsTotal);

      const grand_total_without_tips = parseFloat(
        (
          parseFloat(
            this.cartPrices.grand_total_without_delivery_tips.toString()
          ) - (Number.isFinite(waiterTipsTotal) ? waiterTipsTotal : 0)
        ).toFixed(2)
      );

      if (
        parseFloat(rule.creationMinOrder.toString()) > grand_total_without_tips
      ) {
        return true;
      }
    }

    return false;
  }

  calculatePointsDisableRule(groupApp, store_info, currentPoints, platform) {
    this.store
      .select("deliveryMethodAddress")
      .pipe(first())
      .subscribe((state) => {
        console.log("pointsFactorUsed");
        const disableRule =
          this.pointsCalculationsService.calculateDisablePointRule(
            groupApp,
            store_info,
            currentPoints,
            platform,
            state.orderPickup,
            state.dineIn,
            state.selectedDineInTable
          );

        console.log("pointsDisableRuleArr", disableRule);

        this.pointsDisableRuleArr = _.cloneDeep(disableRule);
        this.pointsDisableRuleMessage = null;

        if (this.pointsDisableRuleArr && this.pointsDisableRuleArr.length) {
          if (
            this.pointsDisableRuleArr[0] &&
            this.pointsDisableRuleArr[0].platform === "all"
          ) {
            this.pointsDisableRuleMessage =
              this.translateService.instant(
                "cart.cart-components.cart-prices.points-earn-are-disabled-for"
              ) +
              " " +
              this.translateService.instant(
                this.pointsCalculationsService.dineInAltDineinAlternativeNames(
                  this.pointsCalculationsService.calculateDeliveryMethod(
                    this.orderPickup,
                    this.dineIn,
                    {
                      alt_dinein_active:
                        this.store_info &&
                        this.store_info.dinein &&
                        this.store_info.alt_dinein_active &&
                        this.selectedDineInTable &&
                        this.selectedDineInTable.alt_dinein,
                      selectedDineInTable: this.selectedDineInTable,
                    }
                  ),
                  this.store_info,
                  this.selectedLang,
                  this.mo_base
                )
              );
          } else if (
            this.pointsDisableRuleArr[0] &&
            this.pointsDisableRuleArr[0].platform !== "all"
          ) {
            const deliveryMethod =
              this.pointsCalculationsService.calculateDeliveryMethod(
                this.orderPickup,
                this.dineIn,
                {
                  alt_dinein_active:
                    this.store_info &&
                    this.store_info.dinein &&
                    this.store_info.alt_dinein_active &&
                    this.selectedDineInTable &&
                    this.selectedDineInTable.alt_dinein,
                  selectedDineInTable: this.selectedDineInTable,
                }
              );

            let showMessageDisablePoints = false;

            if (
              deliveryMethod === "delivery" &&
              _.find(this.pointsDisableRuleArr, {
                order_type: "delivery",
                platform: platform,
              })
            ) {
              showMessageDisablePoints = true;
            } else if (
              deliveryMethod === "takeaway" &&
              _.find(this.pointsDisableRuleArr, {
                order_type: "takeaway",
                platform: platform,
              })
            ) {
              showMessageDisablePoints = true;
            } else if (
              deliveryMethod === "dinein" &&
              _.find(this.pointsDisableRuleArr, {
                order_type: "dinein",
                platform: platform,
              })
            ) {
              showMessageDisablePoints = true;
            } else if (
              deliveryMethod === "altdinein" &&
              _.find(this.pointsDisableRuleArr, {
                order_type: "altdinein",
                platform: platform,
              })
            ) {
              showMessageDisablePoints = true;
            }

            if (showMessageDisablePoints) {
              this.pointsDisableRuleMessage =
                this.translateService.instant(
                  "cart.cart-components.cart-prices.points-earn-are-disabled-for"
                ) +
                " " +
                this.translateService.instant(
                  this.pointsCalculationsService.dineInAltDineinAlternativeNames(
                    deliveryMethod,
                    this.store_info,
                    this.selectedLang,
                    this.mo_base
                  )
                ) +
                " " +
                this.translateService.instant(
                  "cart.cart-components.cart-prices.from"
                ) +
                " " +
                (Capacitor.isNativePlatform()
                  ? this.translateService.instant(
                      "cart.cart-components.cart-prices.mobileApps"
                    )
                  : this.translateService.instant(
                      "cart.cart-components.cart-prices.webpage"
                    )
                ).replace(",", "") +
                " ";
            }
          }
        }
      })
      .unsubscribe();
  }

  calculatePointsFactor(groupApp, store_info, currentPoints, platform) {
    this.store
      .select("deliveryMethodAddress")
      .pipe(first())
      .subscribe((state) => {
        console.log("pointsFactorUsed");
        const pointsObject =
          this.pointsCalculationsService.calculatePointsFactor(
            groupApp,
            store_info,
            currentPoints,
            platform,
            state.orderPickup,
            state.dineIn,
            state.selectedDineInTable
          );

        console.log("pointsFactorUsed", pointsObject);

        this.pointsFactor = _.cloneDeep(pointsObject.pointsFactor);
        this.pointsFactorUsed = _.cloneDeep(pointsObject.pointsFactorUsed);
        this.refreshPointsFactorReminder();
      })
      .unsubscribe();
  }

  refreshPointsFactorReminder() {
    this.pointsFactorReminder = this.pointsFactorReminderMessage();
    this.pointsFactorApplied = this.pointsFactorReminder
      ? null
      : this.pointsFactorAppliedMessage();
  }

  navigateToPointsPage() {
    this.router.navigateByUrl("/points", {
      replaceUrl: true,
    });
  }

  private checkAndShowCouponDiscountMessageDebounce = _.debounce(() => {
    this.checkShowCouponDiscountMessage();
  }, 200);

  checkShowCouponDiscountMessage() {
    this.showCouponDiscountMessage = false;

    _.each(this.selectedCoupons, (coupon) => {
      if (
        this.cartPrices.discount_amount &&
        coupon &&
        (coupon.discount || coupon.discount_fixed) &&
        coupon.discountType !== "percent" &&
        coupon.discountType &&
        this.toFloat(coupon.discount || coupon.discount_fixed) >
          this.toFloat(this.cartPrices.discount_amount)
      ) {
        this.showCouponDiscountMessage = true;
      }
    });
  }

  checkCartInfoMessages() {
    this.store
      .select("groupApp")
      .pipe(first())
      .subscribe((state) => {
        if (state && state.groupApp) {
          let cartInfoMessagesGroup = _.cloneDeep(
            this.infoMessagesService.checkForMobileOrderInfoMessagesGroupApp(
              _.cloneDeep(state.groupApp),
              _.cloneDeep(this.store_info),
              "cart"
            )
          );
          let cartInfoMessagesStore = _.cloneDeep(
            this.infoMessagesService.checkForMobileOrderInfoMessagesStore(
              _.cloneDeep(this.store_info),
              "cart"
            )
          );

          // Filter out guest-only messages for logged-in users (same logic as homepage).
          if (this.currentUser) {
            cartInfoMessagesGroup = _.cloneDeep(
              _.filter(_.cloneDeep(cartInfoMessagesGroup), (infoMessage) => {
                if (infoMessage && !infoMessage.showOnlyToGuests) {
                  return infoMessage;
                }
              })
            );
            cartInfoMessagesStore = _.cloneDeep(
              _.filter(_.cloneDeep(cartInfoMessagesStore), (infoMessage) => {
                if (infoMessage && !infoMessage.showOnlyToGuests) {
                  return infoMessage;
                }
              })
            );
          }

          this.cartInfoMessagesGroup.inline = _.cloneDeep(
            _.filter(cartInfoMessagesGroup, (infoMessage) => {
              if (
                infoMessage &&
                infoMessage.view_type &&
                _.includes(infoMessage.view_type, "inline")
              ) {
                return infoMessage;
              }
            })
          );
          this.cartInfoMessagesStore.inline = _.cloneDeep(
            _.filter(cartInfoMessagesStore, (infoMessage) => {
              if (
                infoMessage &&
                infoMessage.view_type &&
                _.includes(infoMessage.view_type, "inline")
              ) {
                return infoMessage;
              }
            })
          );

          let mo_base = _.cloneDeep(
            _.find(state.groupApp.languages, {
              mo_base: true,
            })
          );

          if (!mo_base) {
            mo_base = "en";
          }
        }
      })
      .unsubscribe();
  }

  async openVatDetailsModal() {
    this.vatLevelsDetailsModal = await this.modalController.create({
      component: VatLevelsDetailsModalComponent,
      componentProps: {},
      backdropDismiss: false,
    });

    await this.vatLevelsDetailsModal.present();

    this.vatLevelsDetailsModal.onDidDismiss().then((data) => {
      this.vatLevelsDetailsModal = null;
    });
  }

  pointsFactorPlatformMessage() {
    const deliveryMethod =
      this.pointsCalculationsService.calculateDeliveryMethod(
        this.orderPickup,
        this.dineIn,
        {
          alt_dinein_active:
            this.store_info &&
            this.store_info.dinein &&
            this.store_info.alt_dinein_active &&
            this.selectedDineInTable &&
            this.selectedDineInTable.alt_dinein,
          selectedDineInTable: this.selectedDineInTable,
        }
      );

    const platform = Capacitor.isNativePlatform() ? "mobile" : "web";

    let returnPlatformMessage = false;

    if (deliveryMethod && deliveryMethod === "delivery") {
      if (
        this.pointsFactorUsed &&
        this.pointsFactor.factor &&
        ((platform === "web" &&
          this.store_info.pointsSystemStoreSettings.delivery &&
          this.store_info.pointsSystemStoreSettings.delivery.apps &&
          this.store_info.pointsSystemStoreSettings.delivery.apps.factor &&
          this.store_info.pointsSystemStoreSettings.delivery.apps.factor > 0 &&
          this.store_info.pointsSystemStoreSettings.delivery.apps.factor !==
            this.pointsFactor.factor) ||
          (platform === "mobile" &&
            this.store_info.pointsSystemStoreSettings.delivery &&
            this.store_info.pointsSystemStoreSettings.delivery.web &&
            this.store_info.pointsSystemStoreSettings.delivery.web.factor &&
            this.store_info.pointsSystemStoreSettings.delivery.web.factor > 0 &&
            this.store_info.pointsSystemStoreSettings.delivery.web.factor !==
              this.pointsFactor.factor))
      ) {
        returnPlatformMessage = true;
      }
    } else if (deliveryMethod && deliveryMethod === "takeaway") {
      if (
        this.pointsFactorUsed &&
        this.pointsFactor.factor &&
        ((platform === "web" &&
          this.store_info.pointsSystemStoreSettings.takeaway &&
          this.store_info.pointsSystemStoreSettings.takeaway.apps &&
          this.store_info.pointsSystemStoreSettings.takeaway.apps.factor &&
          this.store_info.pointsSystemStoreSettings.takeaway.apps.factor > 0 &&
          this.store_info.pointsSystemStoreSettings.takeaway.apps.factor !==
            this.pointsFactor.factor) ||
          (platform === "mobile" &&
            this.store_info.pointsSystemStoreSettings.takeaway &&
            this.store_info.pointsSystemStoreSettings.takeaway.web &&
            this.store_info.pointsSystemStoreSettings.takeaway.web.factor &&
            this.store_info.pointsSystemStoreSettings.takeaway.web.factor > 0 &&
            this.store_info.pointsSystemStoreSettings.takeaway.web.factor !==
              this.pointsFactor.factor))
      ) {
        returnPlatformMessage = true;
      }
    } else if (deliveryMethod && deliveryMethod === "dinein") {
      if (
        this.pointsFactorUsed &&
        this.pointsFactor.factor &&
        ((platform === "web" &&
          this.store_info.pointsSystemStoreSettings.dinein &&
          this.store_info.pointsSystemStoreSettings.dinein.apps &&
          this.store_info.pointsSystemStoreSettings.dinein.apps.factor &&
          this.store_info.pointsSystemStoreSettings.dinein.apps.factor > 0 &&
          this.store_info.pointsSystemStoreSettings.dinein.apps.factor !==
            this.pointsFactor.factor) ||
          (platform === "mobile" &&
            this.store_info.pointsSystemStoreSettings.dinein &&
            this.store_info.pointsSystemStoreSettings.dinein.web &&
            this.store_info.pointsSystemStoreSettings.dinein.web.factor &&
            this.store_info.pointsSystemStoreSettings.dinein.web.factor > 0 &&
            this.store_info.pointsSystemStoreSettings.dinein.web.factor !==
              this.pointsFactor.factor))
      ) {
        returnPlatformMessage = true;
      }
    } else if (deliveryMethod && deliveryMethod === "altdinein") {
      this.pointsFactorUsed &&
        this.pointsFactor.factor &&
        ((platform === "web" &&
          this.store_info.pointsSystemStoreSettings.altdinein &&
          this.store_info.pointsSystemStoreSettings.altdinein.apps &&
          this.store_info.pointsSystemStoreSettings.altdinein.apps.factor &&
          this.store_info.pointsSystemStoreSettings.altdinein.apps.factor > 0 &&
          this.store_info.pointsSystemStoreSettings.altdinein.apps.factor !==
            this.pointsFactor.factor) ||
          (platform === "mobile" &&
            this.store_info.pointsSystemStoreSettings.altdinein &&
            this.store_info.pointsSystemStoreSettings.altdinein.web &&
            this.store_info.pointsSystemStoreSettings.altdinein.web.factor &&
            this.store_info.pointsSystemStoreSettings.altdinein.web.factor >
              0 &&
            this.store_info.pointsSystemStoreSettings.altdinein.web.factor !==
              this.pointsFactor.factor));
      {
        returnPlatformMessage = true;
      }
    }
    if (returnPlatformMessage) {
      return (
        this.translateService.instant("cart.cart-components.cart-prices.from") +
        " " +
        (Capacitor.isNativePlatform()
          ? this.translateService.instant(
              "cart.cart-components.cart-prices.mobileApps"
            )
          : this.translateService.instant(
              "cart.cart-components.cart-prices.webpage"
            )) +
        " "
      );
    }

    return "";
  }

  async openDeliveryCostInfoModal(validStore, deliveryCost) {
    this.deliveryCostInfoModal = await this.modalController.create({
      cssClass: "delivery-cost-info-modal",
      component: DeliveryCostInfoModalComponent,
      componentProps: {
        validStore: validStore,
        deliveryCost: deliveryCost,
      },
      backdropDismiss: false,
    });

    await this.deliveryCostInfoModal.present();

    this.deliveryCostInfoModal.onDidDismiss().then((data) => {
      this.deliveryCostInfoModal = null;
    });
  }

  async openPointsInfoAlert() {
    const factorDisplay =
      this.pointsFactor && this.pointsFactor.factor
        ? this.pointsFactor.factor > 1
          ? "x" + this.pointsFactor.factor.toFixed(2).replace(/\.?0+$/, "")
          : "-" + ((1 - this.pointsFactor.factor) * 100).toFixed(0) + "%"
        : "";

    const minOrderMessage =
      this.pointsFactor &&
      this.pointsFactor.minOrderAmount &&
      this.pointsFactor.minOrderAmount > 0
        ? this.translateService.instant("points.rules.for-order-over") +
          " " +
          this.pointsFactor.minOrderAmount +
          "€"
        : "";

    const factorLabel =
      factorDisplay && this.translateService
        ? factorDisplay +
          " " +
          this.translateService.instant(
            "cart.cart-components.cart-prices.points"
          )
        : factorDisplay;

    const platformMessage = this.pointsFactorPlatformMessage().trim();

    const deliveryMethodLabel = this.translateService.instant(
      this.pointsCalculationsService.dineInAltDineinAlternativeNames(
        this.pointsCalculationsService.calculateDeliveryMethod(
          this.orderPickup,
          this.dineIn,
          {
            alt_dinein_active:
              this.store_info &&
              this.store_info.dinein &&
              this.store_info.alt_dinein_active &&
              this.selectedDineInTable &&
              this.selectedDineInTable.alt_dinein,
            selectedDineInTable: this.selectedDineInTable,
          }
        ),
        this.store_info,
        this.selectedLang,
        this.mo_base
      )
    );

    const reductionMessage =
      this.translateService.instant(
        "cart.cart-components.cart-prices.for-order"
      ) +
      " " +
      deliveryMethodLabel +
      (platformMessage ? " " + platformMessage : "") +
      (minOrderMessage ? " " + minOrderMessage : "") +
      " " +
      this.translateService.instant(
        "cart.cart-components.cart-prices.used-factor-reduction"
      ) +
      " " +
      factorDisplay +
      "!";

    const increaseMessage =
      this.translateService.instant(
        "cart.cart-components.cart-prices.for-order"
      ) +
      " " +
      deliveryMethodLabel +
      " " +
      (minOrderMessage ? minOrderMessage + " " : "") +
      (platformMessage ? platformMessage + " " : "") +
      this.translateService.instant(
        "cart.cart-components.cart-prices.used-factor"
      ) +
      " " +
      factorLabel +
      "!";

    const pointsInfoMessage =
      this.pointsFactor && this.pointsFactor.factor > 1
        ? increaseMessage
        : reductionMessage;

    if (
      this.points_deducted_from_coupon &&
      this.store_info &&
      this.store_info.overridePromoItemsForPointsSystem &&
      !this.pointsFactorUsed
    ) {
      const alert = await this.alertController.create({
        cssClass: "my-custom-class",
        header: this.translateService.instant(
          "cart.cart-components.cart-prices.points-calculation-info"
        ),

        message:
          this.translateService.instant(
            "cart.cart-components.cart-prices.based-on-your-cart-was-removed"
          ) +
          " " +
          this.points_deducted_from_coupon +
          " " +
          this.translateService.instant(
            "cart.cart-components.cart-prices.points-because-of-the-coupon"
          ),
        buttons: ["OK"],
      });

      await alert.present();
    } else if (
      !(
        this.points_deducted_from_coupon &&
        this.store_info &&
        this.store_info.overridePromoItemsForPointsSystem
      ) &&
      this.pointsFactorUsed
    ) {
      const alert = await this.alertController.create({
        cssClass: "my-custom-class",
        header: this.translateService.instant(
          "cart.cart-components.cart-prices.points-calculation-info"
        ),

        message: pointsInfoMessage,
        buttons: [
          {
            text: this.translateService.instant("more"),

            handler: () => {
              this.router.navigateByUrl("/points?segment=rules", {
                replaceUrl: true,
              });
            },
          },
          {
            text: "OK",
            role: "cancel",
            handler: () => {},
          },
        ],
      });

      await alert.present();
    } else if (
      this.points_deducted_from_coupon &&
      this.store_info &&
      this.store_info.overridePromoItemsForPointsSystem &&
      this.pointsFactorUsed
    ) {
      const alert = await this.alertController.create({
        cssClass: "my-custom-class",
        header: this.translateService.instant(
          "cart.cart-components.cart-prices.points-calculation-info"
        ),

        message:
          this.translateService.instant(
            "cart.cart-components.cart-prices.based-on-your-cart-was-removed"
          ) +
          " " +
          this.points_deducted_from_coupon +
          " " +
          this.translateService.instant(
            "cart.cart-components.cart-prices.points-because-of-the-coupon"
          ) +
          "<p>" +
          pointsInfoMessage +
          "</p>",
        buttons: [
          {
            text: this.translateService.instant("more"),
            handler: () => {
              this.router.navigateByUrl("/points?segment=rules", {
                replaceUrl: true,
              });
            },
          },
          {
            text: "OK",
            role: "cancel",
            handler: () => {},
          },
        ],
      });
      await alert.present();
    }
  }

  pointsFactorReminderMessage() {
    if (
      !this.cartProducts ||
      !this.cartProducts.length ||
      !this.groupApp ||
      !this.groupApp.pointsSystem ||
      !this.store_info ||
      !this.store_info.pointsSystemStoreSettings
    ) {
      return null;
    }

    const platform = Capacitor.isNativePlatform() ? "mobile" : "web";
    const deliveryMethod =
      this.pointsCalculationsService.calculateDeliveryMethod(
        this.orderPickup,
        this.dineIn,
        {
          alt_dinein_active:
            this.store_info &&
            this.store_info.dinein &&
            this.store_info.alt_dinein_active &&
            this.selectedDineInTable &&
            this.selectedDineInTable.alt_dinein,
          selectedDineInTable: this.selectedDineInTable,
        }
      );

    const rulesArr = this.pointsCalculationsService.getPointsFactorRulesArray(
      _.cloneDeep(this.store_info)
    );

    if (!rulesArr || !rulesArr.length || !deliveryMethod) {
      return null;
    }

    const uniqueRuleValues = _.uniqBy(
      rulesArr,
      (rule) =>
        `${rule.factor || 0}|${rule.minOrderAmount || 0}|${rule.platform}`
    );
    const uniqueOrderTypes = _.uniq(_.map(rulesArr, "order_type"));
    const allOrderTypesCovered = ["delivery", "takeaway", "dinein", "altdinein"].every(
      (type) => _.some(rulesArr, { order_type: type })
    );
    const omitDeliveryLabel =
      uniqueRuleValues.length === 1 &&
      uniqueOrderTypes.length > 1 &&
      allOrderTypesCovered;

    const currentAmount =
      this.grand_total_without_delivery_tips ||
      (this.cartPrices
        ? this.cartPrices.grand_total_without_delivery_tips
        : null);
    const parsedAmount = currentAmount
      ? parseFloat(currentAmount.toString())
      : null;

    const currentRule = _.chain(rulesArr)
      .filter((rule) => {
        return (
          rule &&
          rule.order_type === deliveryMethod &&
          (rule.platform === "all" || rule.platform === platform)
        );
      })
      .orderBy(
        [
          (rule) => rule.factor || 0,
          (rule) => (rule.minOrderAmount ? -rule.minOrderAmount : 0),
        ],
        ["desc", "desc"]
      )
      .first()
      .value();

    if (
      currentRule &&
      currentRule.minOrderAmount &&
      parsedAmount !== null &&
      parsedAmount < currentRule.minOrderAmount
    ) {
      return this.composePointsFactorMessage(
        currentRule,
        deliveryMethod,
        omitDeliveryLabel
      );
    }

    const alternativeRule = _.chain(rulesArr)
      .filter((rule) => {
        return (
          rule &&
          rule.factor &&
          rule.factor > 1 &&
          (rule.order_type !== deliveryMethod ||
            (rule.platform !== "all" && rule.platform !== platform)) &&
          (!currentRule || rule.factor > (currentRule.factor || 0))
        );
      })
      .orderBy(
        [
          (rule) => rule.factor,
          (rule) => (rule.minOrderAmount ? -rule.minOrderAmount : 0),
        ],
        ["desc", "desc"]
      )
      .first()
      .value();

    if (alternativeRule) {
      return this.composePointsFactorMessage(
        alternativeRule,
        alternativeRule.order_type,
        omitDeliveryLabel
      );
    }

    return null;
  }

  composePointsFactorMessage(rule, deliveryMethod, omitDeliveryLabel = false) {
    const factorDisplay =
      rule.factor && rule.factor > 1
        ? "x" + rule.factor.toFixed(2).replace(/\.?0+$/, "")
        : rule.factor
        ? "-" + ((1 - rule.factor) * 100).toFixed(0) + "%"
        : "";

    const minOrderLabel =
      rule.minOrderAmount && rule.minOrderAmount > 0
        ? this.translateService.instant("points.rules.for-order-over") +
          " " +
          rule.minOrderAmount +
          "€"
        : "";

    const deliveryLabel = omitDeliveryLabel
      ? ""
      : this.translateService.instant(
          this.pointsCalculationsService.dineInAltDineinAlternativeNames(
            deliveryMethod,
            this.store_info,
            this.selectedLang,
            this.mo_base
          )
        );

    const platformLabel =
      rule.platform && rule.platform !== "all"
        ? this.translateService.instant("points.rules." + rule.platform)
        : "";

    const factorText =
      this.translateService.instant(
        "cart.cart-components.cart-prices.used-factor"
      ) +
      " " +
      factorDisplay +
      " " +
      this.translateService.instant("cart.cart-components.cart-prices.points");

    let message = this.translateService.instant(
      "cart.cart-components.cart-prices.for-order"
    );
    if (deliveryLabel) {
      message += " " + deliveryLabel;
    }

    if (platformLabel) {
      message += " " + platformLabel;
    }

    if (minOrderLabel) {
      message += " " + minOrderLabel;
    }

    if (factorText) {
      message += " " + factorText;
    }

    return message;
  }

  pointsFactorAppliedMessage() {
    if (
      !this.pointsFactorUsed ||
      !this.pointsFactor ||
      !this.pointsFactor.factor ||
      this.pointsFactor.factor <= 1
    ) {
      return null;
    }

    const factorDisplay =
      "x" + this.pointsFactor.factor.toFixed(2).replace(/\.?0+$/, "");

    return (
      this.translateService.instant(
        "cart.cart-components.cart-prices.you-win"
      ) +
      " " +
      factorDisplay +
      " " +
      this.translateService.instant("cart.cart-components.cart-prices.points") +
      "!"
    );
  }

  toFloat(num) {
    if (num) {
      const stringNumb = num.toString();

      return parseFloat(parseFloat(stringNumb).toFixed(2));
    } else {
      return 0;
    }
  }

  calculateDeliveryMethod(pickup, dinein) {
    let deliveryMethod;
    if (pickup && !dinein) {
      deliveryMethod = "takeaway";
    } else if (!pickup && !dinein) {
      deliveryMethod = "delivery";
    } else if (!pickup && dinein) {
      deliveryMethod = "dinein";
    }

    return deliveryMethod;
  }

  checkOrderCouponRuleValid(rule, deliveryMethod) {
    if (
      rule &&
      (rule.createForOnlyDeliveryOrder ||
        rule.createForOnlyTakeawayOrder ||
        rule.createForOnlyDineinOrder) &&
      deliveryMethod
    ) {
      return !(
        (rule.createForOnlyDeliveryOrder &&
          !rule.createForOnlyTakeawayOrder &&
          !rule.createForOnlyDineinOrder &&
          deliveryMethod !== "delivery") ||
        (rule.createForOnlyTakeawayOrder &&
          !rule.createForOnlyDeliveryOrder &&
          !rule.createForOnlyDineinOrder &&
          deliveryMethod !== "takeaway") ||
        (rule.createForOnlyDineinOrder &&
          !rule.createForOnlyDeliveryOrder &&
          !rule.createForOnlyTakeawayOrder &&
          deliveryMethod !== "dinein") ||
        (rule.createForOnlyDeliveryOrder &&
          rule.createForOnlyDineinOrder &&
          !rule.createForOnlyTakeawayOrder &&
          deliveryMethod !== "dinein" &&
          deliveryMethod !== "delivery") ||
        (rule.createForOnlyDeliveryOrder &&
          rule.createForOnlyTakeawayOrder &&
          !rule.createForOnlyDineinOrder &&
          deliveryMethod !== "delivery" &&
          deliveryMethod !== "takeaway") ||
        (rule.createForOnlyDineinOrder &&
          rule.createForOnlyTakeawayOrder &&
          !rule.createForOnlyDeliveryOrder &&
          deliveryMethod !== "dinein" &&
          deliveryMethod !== "takeaway") ||
        (rule.createForOnlyDeliveryOrder &&
          rule.createForOnlyDineinOrder &&
          rule.createForOnlyTakeawayOrder &&
          deliveryMethod !== "delivery" &&
          deliveryMethod !== "dinein" &&
          deliveryMethod !== "takeaway")
      );
    }

    return true;
  }

  private filterOrderCouponRulesDebounced = _.debounce(() => {
    if (this.orderPickup === null && this.dineIn === null) {
      return false;
    }

    const deliveryMethod = this.calculateDeliveryMethod(
      this.orderPickup,
      this.dineIn
    );

    const filteredRules = _.filter(this.orderCouponRules || [], (rule) => {
      console.log(
        "asdasdasd",
        rule,
        deliveryMethod,
        this.checkOrderCouponRuleValid(rule, deliveryMethod)
      );

      return !!this.checkOrderCouponRuleValid(rule, deliveryMethod);
    });

    this.filteredOrderCouponRules = _.cloneDeep(filteredRules);
  }, 300);

  substructCouponDiscountAndDiscount(couponDisc, discount) {
    const couponDiscount: number = parseFloat(couponDisc.toString());
    const discounPrices: number = parseFloat(discount.toString());

    if (couponDiscount > discounPrices) {
      return parseFloat((couponDiscount - discounPrices).toString()).toFixed(2);
    }
  }

  cartPricesValidation() {
    let validationObj = {
      id: "cart-prices",
      valid: true,
      errorMessages: [],
    };

    if (this.cartPrices && this.cartPrices.amountToMinimumOrder) {
      validationObj.valid = false;
      validationObj.errorMessages.push(
        this.translateService.instant(
          "cart.cart-components.cart-list.you-need"
        ) +
          " " +
          this.cartPrices.amountToMinimumOrder.toString() +
          "€ " +
          this.translateService.instant(
            "cart.cart-components.cart-list.in-order-to-reach-the-min-order"
          )
      );
    }
    this.store.dispatch(
      new CompleteOrderValidationActions.AddUpdateCompleteOrderValidation(
        _.cloneDeep(validationObj)
      )
    );
  }

  private calculateGiftOnlyFreeOrder() {
    this.giftOnlyFreeOrder = isGiftOnlyFreeOrder(
      this.store_info,
      this.cartProducts,
      this.cartPrices
    );
  }

  ngOnDestroy() {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }

    if (this.vatLevelsDetailsModal) {
      this.vatLevelsDetailsModal.dismiss();
      this.vatLevelsDetailsModal = null;
    }

    if (this.deliveryCostInfoModal) {
      this.deliveryCostInfoModal.unsubscribe();
      this.deliveryCostInfoModal = null;
    }
  }
}
